module.exports = __webpack_public_path__ + "media/img/marquee/marquee-solutions-e7369629f9ece363524279a80d9f0b04.jpg";